import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IFormInputValue } from "../form/FormInputValue";

export interface TFormQualifierAttribute {
  formAttributeId: number;
  attributeName: string;
  attributeType: string;
  id: number;
  labelVisible: boolean;
  name: string;
  orderNumberInsertDisplay: number;
  qualifierId: number;
  required: boolean;
  tooltip: string;
  attributeCode: string;
}

export interface IFormQualifierAttribute extends TFormQualifierAttribute {
  values: IFormInputValue[];
}
const FormQualifierAttribute = Model(
  (model: TFormQualifierAttribute): IFormQualifierAttribute => {
    const _formQualifierAttribute: TFormQualifierAttribute = Object.assign(
      {},
      model
    );

    let create = (
      formQualifierAttribute: IFormQualifierAttribute
    ): IFormQualifierAttribute => {
      let obj = ValidatableObject(formQualifierAttribute);
      return obj;
    };
    let _values: IFormInputValue[] = [];

    let formQualifierAttribute = {
      get formAttributeId() {
        return _formQualifierAttribute.formAttributeId;
      },
      set formAttributeId(value) {
        _formQualifierAttribute.formAttributeId = value;
      },
      get attributeName() {
        return _formQualifierAttribute.attributeName;
      },
      set attributeName(value) {
        _formQualifierAttribute.attributeName = value;
      },
      get attributeType() {
        return _formQualifierAttribute.attributeType;
      },
      set attributeType(value) {
        _formQualifierAttribute.attributeType = value;
      },
      get id() {
        return _formQualifierAttribute.id;
      },
      set id(value) {
        _formQualifierAttribute.id = value;
      },
      get labelVisible() {
        return _formQualifierAttribute.labelVisible;
      },
      set labelVisible(value) {
        _formQualifierAttribute.labelVisible = value;
      },
      get name() {
        return _formQualifierAttribute.name;
      },
      set name(value) {
        _formQualifierAttribute.name = value;
      },
      get orderNumberInsertDisplay() {
        return _formQualifierAttribute.orderNumberInsertDisplay;
      },
      set orderNumberInsertDisplay(value) {
        _formQualifierAttribute.orderNumberInsertDisplay = value;
      },
      get qualifierId() {
        return _formQualifierAttribute.qualifierId;
      },
      set qualifierId(value) {
        _formQualifierAttribute.qualifierId = value;
      },
      get required() {
        return _formQualifierAttribute.required;
      },
      set required(value) {
        _formQualifierAttribute.required = value;
      },
      get tooltip() {
        return _formQualifierAttribute.tooltip;
      },
      set tooltip(value) {
        _formQualifierAttribute.tooltip = value;
      },
      get attributeCode() {
        return _formQualifierAttribute.attributeCode;
      },
      set attributeCode(value) {
        _formQualifierAttribute.attributeCode = value;
      },
      get values() {
        return _values;
      },
      set values(val) {
        _values = val;
      }
    };
    return create(formQualifierAttribute);
  }
);

export default FormQualifierAttribute;
